import React from 'react';
 
export default function Footer() {

  const currentYear = new Date().getFullYear();

  return (
<footer className="bg-white border-t border-gray-200" role="contentinfo">
<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">

        {/* Disclaimer Text */}
<section className="mb-8" aria-label="Legal disclaimer">
<p className="text-xs sm:text-sm text-gray-400 leading-relaxed text-center max-w-6xl mx-auto">

            Advertising is paid for by participating attorneys in a joint advertising program, licensed to practice law in their respective states. A complete list of joint advertising attorneys can be found{' '}
<a 

              href="#" 

              className="text-red-500 hover:text-red-600 underline transition-colors duration-200"

              aria-label="View list of participating attorneys"
>

              here
</a>

            . You can request an attorney by name. We are not a law firm or an attorney referral service. This advertisement is not legal advice and is not a guarantee or prediction of the outcome of your legal matter. Every case is different. The outcome depends on the laws, facts, and circumstances unique to each case. Hiring an attorney is an important decision that should not be based solely on advertising. Request free information about your attorney's background and experience. This advertising does not imply a higher quality of legal services than that provided by other attorneys. This advertising does not imply that the attorneys are certified specialists or experts in any area of law. No legal services will be provided unless a signed agreement between the client and the attorney exists. We use cookies to personalize content and to analyze our traffic. We also share information about your use of our site with our analytics partners, who may combine it with other information you've provided or collected from your use of their services. You consent to our cookies if you continue to use our website.
</p>
</section>
 
        {/* Divider */}
<div className="border-t border-gray-200 mb-6"></div>
 
        {/* Footer Bottom */}
<div className="flex flex-col sm:flex-row items-center justify-between gap-4">

          {/* Copyright */}
<div className="text-xs sm:text-sm text-red-500 font-medium">

            © {currentYear} InjuryCompensation.com
</div>
 
          {/* Footer Links */}
<nav aria-label="Footer navigation">
<ul className="flex flex-wrap items-center justify-center gap-3 sm:gap-6">
<li>
<a 

                  href="#terms" 

                  className="text-xs sm:text-sm text-red-500 hover:text-red-600 transition-colors duration-200 font-medium"

                  aria-label="Terms and Conditions"
>

                  Terms & Conditions
</a>
</li>
<li className="text-gray-300">|</li>
<li>
<a 

                  href="#privacy" 

                  className="text-xs sm:text-sm text-red-500 hover:text-red-600 transition-colors duration-200 font-medium"

                  aria-label="Privacy Policy"
>

                  Privacy Policy
</a>
</li>
<li className="text-gray-300">|</li>
<li>
<a 

                  href="#partner" 

                  className="text-xs sm:text-sm text-red-500 hover:text-red-600 transition-colors duration-200 font-medium"

                  aria-label="Partner with Us"
>

                  Partner with Us
</a>
</li>
<li className="text-gray-300">|</li>
<li>
<a 

                  href="#do-not-sell" 

                  className="text-xs sm:text-sm text-red-500 hover:text-red-600 transition-colors duration-200 font-medium"

                  aria-label="Do Not Sell My Information"
>

                  Do Not Sell
</a>
</li>
</ul>
</nav>
</div>
</div>
 
      {/* SEO-optimized structured data */}
<script type="application/ld+json">

        {JSON.stringify({

          "@context": "https://schema.org",

          "@type": "WPFooter",

          "name": "InjuryCompensation.com Footer",

          "copyrightYear": currentYear,

          "copyrightHolder": {

            "@type": "Organization",

            "name": "InjuryCompensation.com",

            "url": "https://injurycompensation.com"

          },

          "hasPart": [

            {

              "@type": "WebPage",

              "name": "Terms & Conditions",

              "url": "#terms"

            },

            {

              "@type": "WebPage",

              "name": "Privacy Policy",

              "url": "#privacy"

            },

            {

              "@type": "WebPage",

              "name": "Partner with Us",

              "url": "#partner"

            },

            {

              "@type": "WebPage",

              "name": "Do Not Sell",

              "url": "#do-not-sell"

            }

          ]

        })}
</script>
</footer>

  );

}
 